var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "export-job-container" }, [
    _c(
      "h3",
      { staticClass: "m-b-5 export-job-name", attrs: { title: _vm.job.name } },
      [_vm._v("\n    " + _vm._s(_vm.job.name) + "\n  ")]
    ),
    _vm._v(" "),
    _vm.isJobPending
      ? _c("div", [
          _c(
            "div",
            { staticClass: "uiv text-nowrap m-b-0" },
            [
              _c("progress-bar", {
                staticClass: "m-b-0",
                attrs: {
                  type: "success",
                  label: "",
                  active: _vm.isProgressIndefinite,
                  striped: _vm.isProgressIndefinite,
                  "label-text": _vm.progressFullDescription
                },
                model: {
                  value: _vm.progressState,
                  callback: function($$v) {
                    _vm.progressState = $$v
                  },
                  expression: "progressState"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isJobReady
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "toast-close-button",
              attrs: { type: "button" },
              on: { click: _vm.dismissJob }
            },
            [
              _c("span", {
                directives: [
                  { name: "t", rawName: "v-t", value: "X", expression: "'X'" }
                ]
              })
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c(
              "a",
              {
                attrs: {
                  href: _vm.jobStatus.url,
                  target: _vm.aHrefDownloadTarget,
                  download: ""
                }
              },
              [
                _c("i", { staticClass: "fa fa-download m-r-5" }),
                _vm._v("\n        " + _vm._s(_vm.jobDownloadTitle) + "\n      ")
              ]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isJobError
      ? _c("div", [
          _c(
            "button",
            {
              staticClass: "toast-close-button",
              attrs: { type: "button" },
              on: { click: _vm.dismissJob }
            },
            [
              _c("span", {
                directives: [
                  { name: "t", rawName: "v-t", value: "X", expression: "'X'" }
                ]
              })
            ]
          ),
          _vm._v(" "),
          _c("div", [
            _c("strong", [
              _c("i", { staticClass: "fa fa-exclamation-triangle m-r-5" }),
              _vm._v(" "),
              _c("span", {
                directives: [
                  {
                    name: "t",
                    rawName: "v-t",
                    value: "ERROR_PLEASE_TRY_AGAIN",
                    expression: "'ERROR_PLEASE_TRY_AGAIN'"
                  }
                ]
              })
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }